import { Injectable } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { Database, objectVal, ref } from '@angular/fire/database';
import { debounce, of, timer } from 'rxjs';
import { ToastRef, ToastService } from './toast';


@Injectable({
  providedIn: 'root'
})
export class NoInternetService {
  toastRef?: ToastRef;

  constructor(private readonly toast: ToastService, private readonly db: Database, private readonly analytics: Analytics) {
    objectVal(ref(this.db, `.info/connected`)).pipe(
      debounce(connected => connected ? of(0) : timer(10000)),
    ).subscribe(connected => {
      if (connected) {
        this.toastRef?.hide();
        this.toastRef = undefined;
      } else {
        logEvent(this.analytics, 'no-db-connection');

        if (!this.toastRef) {
          this.toastRef = this.toast.show(`Lost internet. Check your connection`, {ongoing: true});
        }
      }
    });
  }
}
